// routes
import { PATH_MAIN, PATH_USER } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
    <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
    user: icon('ic_user'),
    ecommerce: icon('ic_ecommerce'),
    analytics: icon('ic_analytics'),
    dashboard: icon('ic_dashboard'),
    master: icon('ic_master'),
    settings: icon('ic_settings'),
    helpdesk: icon('ic_helpdesk'),
    home: icon('ic_development'),
    list: icon('ic_list'),
};

const navConfig = [
    // GENERAL
    // ----------------------------------------------------------------------
    {
        items: [
            { title: 'User', path: PATH_USER.user, icon: ICONS.user },
            { title: 'Module Role Access List', path: PATH_USER.moduleroleaccesslistpage, icon: ICONS.list },
            // {
            //    title: 'master', path: PATH_MAIN.master.root, icon: ICONS.master,
            //    children: [
            //        { title: 'Franchise', path: PATH_MAIN.master.one },
            //        { title: 'Sub Franchise', path: PATH_MAIN.master.two },
            //        { title: 'Geography', path: PATH_MAIN.master.three },
            //        { title: 'Products', path: PATH_MAIN.master.four },
            //        { title: 'Dealers', path: PATH_MAIN.master.five },
            //        { title: 'Accounts', path: PATH_MAIN.master.six },
            //        { title: 'Surgeons', path: PATH_MAIN.master.one },
            //        { title: 'Executives', path: PATH_MAIN.master.two },
            //        { title: 'Sales Hierarchy', path: PATH_MAIN.master.three },
            //        { title: 'Standard NR', path: PATH_MAIN.master.four },
            //        { title: 'Special NR', path: PATH_MAIN.master.five },
            //    ],
            // },
            // { title: 'Helpdesk', path: PATH_MAIN.five, icon: ICONS.settings },
            // { title: 'Settings', path: PATH_MAIN.six, icon: ICONS.helpdesk },
        ],
    }
];


export default navConfig;
